import { render, staticRenderFns } from "./CadastrarCompraAcessor.vue?vue&type=template&id=38c692cc&scoped=true&"
import script from "./CadastrarCompraAcessor.vue?vue&type=script&lang=js&"
export * from "./CadastrarCompraAcessor.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarCompraAcessor.vue?vue&type=style&index=0&id=38c692cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c692cc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c692cc')) {
      api.createRecord('38c692cc', component.options)
    } else {
      api.reload('38c692cc', component.options)
    }
    module.hot.accept("./CadastrarCompraAcessor.vue?vue&type=template&id=38c692cc&scoped=true&", function () {
      api.rerender('38c692cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/components/Acessor/CadastrarCompraAcessor.vue"
export default component.exports